(function ($) {
    $(() => {
        $('select.js-nice-select').niceSelect();

        $('#language_checkbox').on('click', function () {
            var languageToggle = $('input[name=language_checkbox]');
            $.each(languageToggle, function (index, value) {
                console.log(value.id + ':' + value.checked);
                if (value.checked === true) {
                    window.location.href = localize.url + '/en/';
                } else {
                    window.location.href = localize.url;
                }
            });
        });


        if (window.location.href.indexOf("/en") > -1) {
            $('#language_checkbox').attr('checked', 'checked');
        }

        FastClick.attach(document.body);
    });
})(jQuery);
